import { useEffect } from 'react'
import { toast } from 'sonner'
import { handleNewVersion, watchAppUpdates } from '../../lib/app-update'

const TOAST_ID = 'app-update'

const showUpdateToast = () =>
  toast('Une nouvelle version est disponible', {
    id: TOAST_ID,
    // Reste affiché jusqu'au clic ; fermé, il revient à la vérification suivante.
    duration: Infinity,
    closeButton: true,
    action: { label: 'Mettre à jour', onClick: () => window.location.reload() },
  })

/**
 * Prévient l'utilisateur qu'une nouvelle version de l'app est en ligne (vérification toutes les
 * 10 minutes) : un toast « Mettre à jour », et c'est lui qui choisit quand recharger. À monter une
 * fois, au plus haut de l'app pour surveiller toutes les pages ; le toast s'affiche dans le
 * `Toaster` monté sur la page en cours (aucun toast sans `Toaster`, le rechargement de nuit marche
 * quand même).
 *
 * `reloadAtNight` (écran de la boutique, que personne ne touche forcément) : entre 4h et 5h, l'app
 * se recharge d'elle-même si elle a une version de retard.
 */
export function AppUpdateToast({
  enabled,
  reloadAtNight = false,
}: {
  /** Faux en dev local : pas de déploiement à surveiller. */
  enabled: boolean
  reloadAtNight?: boolean
}) {
  useEffect(() => {
    if (!enabled) return
    return watchAppUpdates({
      onUpdate: (latestEntry) =>
        handleNewVersion(latestEntry, { reloadAtNight, notify: showUpdateToast }),
    })
  }, [enabled, reloadAtNight])

  return null
}
